<app-list-page
  [headline]="
    (lastResult.totalNumberResultsets === 1 ? 'project.size.singular' : 'project.size.plural')
      | translate: { projects: lastResult.totalNumberResultsets || 0 }
  "
  (downloadList)="downloadTheList()"
  [detailsLoaded]="selectedProject && items.size > 0 ? true : false">
  <hoc-filter-block
    data-testid="project-filter-block"
    filter
    [textSearch]="searchForName"
    (changed)="filterBlockChanged($event)"
    defaultSorting="asc"
    [filters]="filtersForBlock"></hoc-filter-block>
  <hoc-grouped-list
    data-testid="project-list"
    list
    [loading]="loading"
    [groupLetters]="groupLetters"
    [items]="items"
    [loadingBlock]="loadingBlock"
    [footerBlock]="footerBlock"
    [groupBlock]="groupBlock"
    [itemBlock]="itemBlock"
    [emptyItemsBlock]="emptyItemsBlock"
    (scrolledToEnd)="scrolledToEnd()">
  </hoc-grouped-list>
  <app-project-details
    details
    [project]="selectedProject"
    [isAdmin]="isAdmin"
    (closeClicked)="closeDrawer()"></app-project-details>
</app-list-page>

<ng-template #emptyItemsBlock>
  <app-empty-list-page (backButtonClicked)="handleEmptyList()"></app-empty-list-page>
</ng-template>

<ng-template #groupBlock let-letter>
  <h3 class="list-title-text">{{ letter }}</h3>
</ng-template>

<ng-template #loadingBlock>
  <app-list-placeholder [hasTitle]="true" [columnCount]="3" [lineCount]="2" />
</ng-template>

<ng-template #itemBlock let-item>
  <app-list-item [data]="getProjectListItem(item)" (onClicked)="clickedOnProject(item)"></app-list-item>
</ng-template>

<ng-template #footerBlock>
  <div #footerContainer class="px-3 py-4">
    @if (loadMode === 'paged' && items.size > 0) {
      <gx-pagination
        data-testid="project-list-pagination"
        [data]="pagination"
        (newPage)="gotoPage($event)"
        [availablePageSizes]="config.pageSizes"
        [currentPageSize]="filter.pageSize"
        [lengthBeginSegment]="4"
        [lengthEndSegment]="4"
        (newPageSize)="newPageSize($event)" />
    }
  </div>
</ng-template>
